/**
 * @module util/share
 */

import { shareApi } from './detect';

/**
 * Web Share API: Enabled by default in Chrome for Android release 61.
 * https://www.chromestatus.com/feature/5668769141620736
 *
 * @param {object} options
 * @param callback
 */
function share(options, callback = () => {}) {
    if (shareApi()) {
        navigator.share({ title: options.subject,
            text: options.text,
            url: `${options.jobLink}${options.utmParams}`,
            ...options }).then(() => callback(true)).catch((error) => callback(error));
    }
}

export { share };
